import React, { useEffect, useState } from 'react'
import Home from '../home/home'
import './userHome.css'
import { Button } from '@mui/material'
import Navbar from '../navbar/navbar'
import { downloadFile, uploadFile } from '../../api.service/user.service'
import CustomSnackbar from '../../widgets/snackbar/snackbar'
import Loader from '../../widgets/loader/loader'
import FileUploaderDownloader from '../../widgets/fileUploaderDownloader/fileUploaderDownloader'

const UserHome = () => {
    const [auditCandidateName, setAuditCandidateName] = useState<any>()
    const [isAudit, setIsAudit] = useState<boolean>(false)
    const [loader, setLoader] = useState<boolean>(false)
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        backgroundColor: ''
    })
    const [fileDms, setFileDms] = useState<string>('')

    const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];

            console.log(selectedFile, 'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF')
            setLoader(true)
            uploadFile(selectedFile).then((result: any) => {
                if (result.data) {
                    setFileDms(result.data.dmscode)
                    setOpenSnackbar({
                        open: true,
                        message: 'File Uploaded',
                        backgroundColor: 'green'
                    });
                }
                setLoader(false)
            }).catch(error => {
                if (error) {
                    setOpenSnackbar({
                        open: true,
                        message: 'File Uploading Faile...',
                        backgroundColor: 'red'
                    });
                    setLoader(false)
                }
            })
        }

        setOpenSnackbar({
            open: false,
            message: '',
            backgroundColor: ''
        });
    };
    const download = () => {
        setLoader(true)
        downloadFile(fileDms).then((result: any) => {
            const linkSource = window.URL.createObjectURL(result.data);
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download = 'download.jpg';
            downloadLink.click();
            setOpenSnackbar({
                open: true,
                message: 'File Downloaded',
                backgroundColor: 'green'
            });
            setLoader(false)
        }).catch((error) => {
            if (error) {
                setOpenSnackbar({
                    open: true,
                    message: 'File Downloading Faile...',
                    backgroundColor: 'red'
                });
                setLoader(false)
            }
        })


    }

    const handleCloseSnackbar = () => {
        setOpenSnackbar({
            open: false,
            message: '',
            backgroundColor: ''
        })
    }

    const handleAudit = (params: any) => {
        console.log(params, 'Paramsmsssssssssssssssssss')
        setIsAudit(params.audit)
        setAuditCandidateName({ 'name': params.name, 'id': params.id })
    }

    const handleBack = () => {
        setIsAudit(false)
    }


    return (
        <div className='main-container'>
            <Navbar isAdmin={false} />
            <div style={{ height: 'calc(100% - 70px)' }}>

                <div className='heading1'>
                    <h2>
                        {isAudit ? 'Audit Log:' : 'User'} {' '}
                        {isAudit && (
                            <>
                                {auditCandidateName.name}{' '}
                                (<span className='customer-id'>{auditCandidateName.id}</span>)
                            </>
                        )}
                    </h2>
                    {isAudit ? <Button variant='contained' onClick={handleBack}>Back</Button> : <FileUploaderDownloader />}
                </div>
                <div className='table-container1'>
                    <div className='container-100'>
                        <Home onAudit={handleAudit} isAuditData={isAudit} />
                    </div>
                </div>
            </div>
            <CustomSnackbar data={openSnackbar.open ? openSnackbar : false} onClose={handleCloseSnackbar} />
            <Loader loader={loader} />

        </div>
    )
}

export default UserHome